import React from 'react'

import { Container } from './styles'

const NotFound = () => {
    return <Container>NOT FOUND</Container>
}

export default NotFound
